import React, { useState } from "react";
import { Col, Container, Row } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import arrow from "../assets/kangaroo/whitearrow.png";
import Form from "../component/Form/Form";
import Destinationcountry from "../services/Destinationcountry";
import { imageBaseApi } from "../services/imageBaseApi";

const Explore = () => {
  const router = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const toggleModal = () => setModalOpen(!modalOpen);

  const fetchCountryData = async () => {
    const response = await Destinationcountry.getList();
    return response;
  };

  const {
    isPending,
    error,
    data: countrydata,
  } = useQuery({
    queryKey: ["countryData"],
    queryFn: fetchCountryData,
  });

  // Service-based overlays instead of country names
  const overlays = {
    "VISA & MIGRATION": "rgba(240, 90, 70, 0.55)",
    EDUCATION: "rgba(0, 200, 200, 0.5)",
    "OVERSEAS HEALTH INSURANCE": "rgba(200, 180, 60, 0.54)",
    OSHC: "rgba(200, 180, 60, 0.54)",
    TAX: "rgba(140, 10, 198, 0.5)",
    "TAX RETURN": "rgba(140, 10, 198, 0.5)",
  };

  const CountryCard = ({ image, overlay, title, caption }) => (
    <div
      className="position-relative rounded-5 mx-auto"
      style={{
        height: "clamp(200px, 40vw, 360px)",
        width: "clamp(200px, 40vw)",
        overflow: "hidden",
        transition: "transform 0.3s ease, box-shadow 0.3s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "scale(1.05)";
        e.currentTarget.style.boxShadow = "0 8px 20px rgba(0, 0, 0, 0.3)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "scale(1)";
        e.currentTarget.style.boxShadow = "none";
      }}
    >
      {/* Image */}
      <img
        src={image}
        loading="lazy"
        alt={title}
        className="w-100 h-100"
        style={{ objectFit: "cover" }}
      />

      {/* Overlay */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: overlay,
        }}
      />

      {/* Text container */}
      <div
        className="position-absolute w-100 px-3 d-flex align-items-end"
        style={{ bottom: "15%", left: 0, zIndex: 2 }}
      >
        <div
          className="font-level-5 lh-1 mb-0 ms-2 overflow-hidden"
          style={{ color: "white" }}
          dangerouslySetInnerHTML={{ __html: title.replace(/<br\s*\/?>/gi, " ") }}
        />
      
      </div>
    </div>
  );

  if (isPending) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;
  if (!countrydata || !Array.isArray(countrydata)) {
    return <div>No country data available</div>;
  }

  return (
    <div className="main-container">
      <Container
        fluid
        className="justify-content-start"
       style={{marginBottom:"clamp(1rem, 16vw, 10rem)"}}
      >
        <Row
          className="justify-content-between"
          style={{ marginTop: "1rem", cursor: "pointer" }}
        >
          <h1
            className="lh-1 font-level-4 fw-normal text-start p-0 "
            style={{ color: "#860391", marginBottom:"clamp(1rem,5vw,4.2rem)" }} 
          >
            EXPLORE THE SERVICES THAT <br className="d-none d-md-block" />
            HELP YOU THRIVE IN AUSTRALIA
          </h1>

          {/* Map through first 3 services */}
          <div className="row g-3 m-0 p-0"> 

          {countrydata?.slice(0, 3).map((service, index) => (
            <Col
              key={service.id}
              xs="12"
              sm="6"
              lg="4"
              xl="4"
              className={`cursor-pointer p-0 ${
                index === 0
                  ? "pe-sm-2"
                  : index === 1
                  ? "ps-sm-2 pe-lg-2 mt-3 mt-sm-0"
                  : "ps-lg-2 mt-3 mt-lg-0"
              }`}
              onClick={() => router(`/services/${service?.slug}`)}
            >
              <CountryCard
                image={`${imageBaseApi}${service.thumbnailMedia?.url}`}
                overlay={
                  overlays[service.name.toUpperCase()] || "rgba(0,0,0,0.5)"
                }
                title={service.name.toUpperCase().replace(/ /g, " <br/>")}
              />
            </Col>
          ))}
          </div>
        </Row>

        <Row className="mt-3" style={{ cursor: "pointer" }}>
          {/* Map through remaining services */}
          {countrydata?.slice(3).map((service, index) => (
            <Col
              key={service.id}
              xs="12"
              sm="6"
              lg="4"
              xl="4"
              className={`p-0 ${
                index === 0 ? "pe-sm-2" : "ps-lg-2 mt-3 mt-lg-0"
              }`}
              onClick={() => router(`/services/${service?.slug}`)}
            >
              <CountryCard
                image={`${imageBaseApi}${service.thumbnailMedia?.url}`}
                overlay={
                  overlays[service.name.toUpperCase()] || "rgba(0,0,0,0.5)"
                }
                title={service.name.toUpperCase().replace(/ /g, " <br/>")}
              />
            </Col>
          ))}

          {/* "Start Your Next Step" card */}
          <Col
            xs="12"
            sm="6"
            lg="4"
            xl="4"
            className="d-flex justify-content-center p-0 ps-lg-2 mt-3 mt-lg-0"
          >
            <div
              className="d-flex flex-column justify-content-center align-items-start rounded-5 px-5 pt-5"
              style={{
                backgroundColor: "#ff4d1d",
                height: "clamp(200px, 40vw, 360px)",
                width: "100%",
                maxWidth: "500px",
                cursor: "pointer",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onClick={toggleModal}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.05)";
                e.currentTarget.style.boxShadow =
                  "0 8px 20px rgba(255, 77, 29, 0.5)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1)";
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              <img
                src={arrow}
                alt="Arrow"
                loading="lazy"
                style={{
                  height: "clamp(40px, 8vw, 60px)",
                  marginBottom: "1rem",
                }}
              />
              <h1
                className="font-level-5 text-start"
                style={{
                  color: "white",
                }}
              >
                START <br /> YOUR <br />
                NEXT STEP
              </h1>
            </div>
          </Col>
        </Row>

        <div>
          <Form
            modal={modalOpen}
            toggle={toggleModal}
            heading="Start Your Next Step"
            description="Tell us a bit about yourself and we’ll guide you to the right support, whether it’s visa, admissions, compliance or student services."
            closingMessage="YOU'RE ALL SET!"
            closingDesc="Our team will help you explore the best global options for your study journey"
            Explore={true}
            formOrigin={3}
          />
        </div>
      </Container>
    </div>
  );
};

export default Explore;
